const PREFILL_KEY = 'takamatsu_visit_prefill_v1';

function consumeVisitDatePrefill() {
	try {
		const raw = sessionStorage.getItem(PREFILL_KEY);
		if (!raw) return null;
		sessionStorage.removeItem(PREFILL_KEY);
		const data = JSON.parse(raw);
		return typeof data?.visit_date_value === 'string' ? data.visit_date_value : null;
	} catch {
		return null;
	}
}

function readScheduleRows(root) {
	const container = root.querySelector('#visit-schedule-row-data');
	if (!(container instanceof HTMLElement)) return [];
	return [...container.querySelectorAll('[data-visit-schedule-row]')].map((el) => ({
		time: el.getAttribute('data-time') || '',
		slots: (el.getAttribute('data-slots') || '').split(','),
	}));
}

function parseHiddenValue(value) {
	const match = value.match(/^(.+?\([^)]+\))\s+(.+)$/);
	if (!match) return null;
	return { dateValue: match[1], time: match[2], combined: value };
}

function getDayIndex(root, dateValue) {
	for (const card of root.querySelectorAll('.visit__dateCard[data-date-value]')) {
		if (!(card instanceof HTMLElement)) continue;
		if (card.getAttribute('data-date-value') !== dateValue) continue;
		const index = Number(card.getAttribute('data-day-index'));
		return Number.isNaN(index) ? -1 : index;
	}
	return -1;
}

function syncDateCards(root, selectedDateValue) {
	root.querySelectorAll('.visit__dateCard[data-date-value]').forEach((node) => {
		if (!(node instanceof HTMLButtonElement)) return;
		const selected = Boolean(selectedDateValue && node.getAttribute('data-date-value') === selectedDateValue);
		node.classList.toggle('is-selected', selected);
		node.setAttribute('aria-pressed', selected ? 'true' : 'false');
	});
}

function syncTimeSlots(root, combinedValue) {
	root.querySelectorAll('.visit__timeSlot[data-value]').forEach((node) => {
		if (!(node instanceof HTMLButtonElement)) return;
		const value = node.getAttribute('data-value') || '';
		const selected = Boolean(combinedValue && value === combinedValue);
		node.classList.toggle('is-selected', selected);
		node.setAttribute('aria-pressed', selected ? 'true' : 'false');
	});
}

function renderTimes(root, rows, dayIndex, selectedCombined) {
	const grid = root.querySelector('[data-visit-time-grid]');
	if (!(grid instanceof HTMLElement)) return;

	const dateCard = root.querySelector(`.visit__dateCard[data-day-index="${dayIndex}"]`);
	const dateValue = dateCard instanceof HTMLButtonElement ? dateCard.getAttribute('data-date-value') || '' : '';

	grid.innerHTML = '';

	rows.forEach((row) => {
		const status = row.slots[dayIndex];
		if (status !== 'circle') return;

		const value = `${dateValue} ${row.time}`;
		const button = document.createElement('button');
		button.type = 'button';
		button.className = 'visit__timeSlot';
		button.setAttribute('data-value', value);
		button.textContent = row.time;
		if (selectedCombined === value) {
			button.classList.add('is-selected');
			button.setAttribute('aria-pressed', 'true');
		} else {
			button.setAttribute('aria-pressed', 'false');
		}
		grid.appendChild(button);
	});
}

function restoreFromHidden(root, rows, hidden) {
	const parsed = parseHiddenValue(hidden.value.trim());
	if (!parsed) return;

	const dayIndex = getDayIndex(root, parsed.dateValue);
	if (dayIndex < 0) return;

	syncDateCards(root, parsed.dateValue);
	renderTimes(root, rows, dayIndex, parsed.combined);
	syncTimeSlots(root, parsed.combined);
}

export function initVisitSchedule() {
	const root = document.querySelector('[data-visit-schedule]');
	if (!(root instanceof HTMLElement)) return;

	const hidden = root.querySelector('#visit-date-1');
	if (!(hidden instanceof HTMLInputElement)) return;

	const rows = readScheduleRows(root);
	let selectedDateValue = '';

	const prefillDate = consumeVisitDatePrefill();
	if (prefillDate) {
		selectedDateValue = prefillDate;
		hidden.value = '';
		syncDateCards(root, prefillDate);
		const dayIndex = getDayIndex(root, prefillDate);
		if (dayIndex >= 0) renderTimes(root, rows, dayIndex, '');
	} else {
		const initial = hidden.value.trim();
		if (initial) {
			const parsed = parseHiddenValue(initial);
			if (parsed) selectedDateValue = parsed.dateValue;
			restoreFromHidden(root, rows, hidden);
		}
	}

	hidden.addEventListener('change', () => {
		const current = hidden.value.trim();
		const parsed = parseHiddenValue(current);
		if (parsed) {
			selectedDateValue = parsed.dateValue;
			syncDateCards(root, selectedDateValue);
			const dayIndex = getDayIndex(root, parsed.dateValue);
			if (dayIndex >= 0) renderTimes(root, rows, dayIndex, current);
			syncTimeSlots(root, current);
			return;
		}

		selectedDateValue = selectedDateValue || '';
		syncDateCards(root, selectedDateValue);
		if (selectedDateValue) {
			const dayIndex = getDayIndex(root, selectedDateValue);
			if (dayIndex >= 0) renderTimes(root, rows, dayIndex, '');
		} else {
			const grid = root.querySelector('[data-visit-time-grid]');
			if (grid instanceof HTMLElement) grid.innerHTML = '';
		}
		syncTimeSlots(root, '');
	});

	root.addEventListener('click', (event) => {
		const target = event.target;
		if (!(target instanceof HTMLElement)) return;

		const dateButton = target.closest('.visit__dateCard[data-date-value]');
		if (dateButton instanceof HTMLButtonElement) {
			const dateValue = dateButton.getAttribute('data-date-value') || '';
			const dayIndex = Number(dateButton.getAttribute('data-day-index'));
			if (Number.isNaN(dayIndex)) return;

			selectedDateValue = dateValue;
			hidden.value = '';
			syncDateCards(root, dateValue);
			renderTimes(root, rows, dayIndex, '');
			syncTimeSlots(root, '');
			hidden.dispatchEvent(new Event('change', { bubbles: true }));
			return;
		}

		const timeButton = target.closest('button.visit__timeSlot[data-value]');
		if (timeButton instanceof HTMLButtonElement) {
			const value = timeButton.getAttribute('data-value') || '';
			hidden.value = hidden.value.trim() === value ? '' : value;
			syncTimeSlots(root, hidden.value.trim());
			hidden.dispatchEvent(new Event('change', { bubbles: true }));
		}
	});
}
